const getToken = state => state.token;

const getUser = state => state.user;

const getClient = state => state.client;

export default {
  getToken,
  getUser,
  getClient
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js